import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isServiceRequestSupportedForMailbox } from 'owa-service/lib/utils/isServiceRequestSupportedForMailbox';
import { isMailboxSharedOrDelegate } from 'owa-account-shared-mailbox-utils';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to determine if the outlook favorites service should be called
 */
export const localFolderFavoriteCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (mailboxInfo) {
            const isShared = isMailboxSharedOrDelegate(mailboxInfo);
            const isArchive = mailboxInfo.type === 'ArchiveMailbox';
            const isPst = !isServiceRequestSupportedForMailbox(mailboxInfo);

            // We only support local folder favorites for shared, archive, or PST mailboxes
            const isLocalFolderFavoriteSupported = isShared || isArchive || isPst;

            if (isMonarchMultipleAccountsEnabled()) {
                return isLocalFolderFavoriteSupported;
            } else {
                // For OWA, we do not support local folder favorites
                return false;
            }
        }
        return false;
    },
};
